import { PolicyListItem } from '@/shared/types/policy.types'
import { GetPolicyResponse } from '@/shared/types/response.types'
import { AxiosResponse } from 'axios'
import HttpService from '../HttpService'
import { formDataGenerator } from '@/shared/api/api.utils'

export class PolicyService extends HttpService {  
  async getPolicyList(
    passportNo: string,
    birthdate: string,
    response_token: string,
    controller?: AbortController
  ): Promise<PolicyListItem[]> {
    const { data } = await this.post<AxiosResponse>(
      'getvisitorspolicy',
      formDataGenerator({
        passportNo,
        birthdate,
        response_token,
      }),
      { signal: controller?.signal }
    )
    return data.data
  }

  getPolicy(): Promise<GetPolicyResponse> {
    return this.post('getpolicy')
  }
}
